import { weddingConfig } from '@/data/weddingConfig';
import { weddingImages } from '@/data/weddingImages';
import WeddingImage from '@/components/base/WeddingImage';
import { nameFontSize } from './nameSizing';
import { useEffect, useState } from 'react';

export default function Hero() {
  const [showHint, setShowHint] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setShowHint(window.scrollY < 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className="relative flex h-[100svh] min-h-[560px] w-full items-center justify-center overflow-hidden bg-background-950">
      {/* Background image + deep espresso overlay */}
      <div className="absolute inset-0">
        <WeddingImage
          src={weddingImages.hero.src}
          fallback={weddingImages.hero.fallback}
          alt={weddingImages.hero.alt}
          loading="eager"
          fetchPriority="high"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-950/50" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/30 via-transparent to-background-950/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-3xl px-6 text-center">
        {/* Ornamental top line */}
        <div className="mb-8 flex items-center justify-center gap-3 opacity-70">
          <span className="h-px w-14 bg-primary-300/70" />
          <span className="h-1.5 w-1.5 rotate-45 bg-primary-300/70" />
          <span className="h-px w-14 bg-primary-300/70" />
        </div>

        <h1
          className="font-script leading-[1.15] text-balance break-words text-background-50 drop-shadow-md"
          style={{ fontSize: nameFontSize(weddingConfig.brideName, 'hero') }}
        >
          {weddingConfig.brideName}
        </h1>

        <p className="my-5 flex items-center justify-center gap-5 font-heading italic text-background-50/85">
          <span className="hidden h-px w-8 bg-background-50/40 sm:block" />
          <span className="text-3xl sm:text-4xl md:text-5xl">&</span>
          <span className="hidden h-px w-8 bg-background-50/40 sm:block" />
        </p>

        <h1
          className="font-script leading-[1.15] text-balance break-words text-background-50 drop-shadow-md"
          style={{ fontSize: nameFontSize(weddingConfig.groomName, 'hero') }}
        >
          {weddingConfig.groomName}
        </h1>

        {/* Date */}
        <div className="mt-12 md:mt-16">
          <p className="font-body text-sm tracking-[0.4em] text-background-50/90 uppercase sm:text-base md:text-lg">
            {weddingConfig.day} · {weddingConfig.month} · {weddingConfig.year}
          </p>
        </div>

        <div className="mt-7">
          <p className="font-heading text-lg italic tracking-wide text-background-50/80 sm:text-xl md:text-2xl">
            {weddingConfig.heroSubtitle}
          </p>
        </div>

        {/* Ornamental bottom line */}
        <div className="mt-10 flex items-center justify-center gap-3 opacity-70">
          <span className="h-px w-14 bg-primary-300/70" />
          <span className="h-1.5 w-1.5 rotate-45 bg-primary-300/70" />
          <span className="h-px w-14 bg-primary-300/70" />
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className={`absolute bottom-8 left-1/2 z-10 -translate-x-1/2 transition-opacity duration-700 ${
          showHint ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
      >
        <div className="flex flex-col items-center gap-3 text-background-50/70">
          <span className="font-body text-[10px] uppercase tracking-[0.3em]">
            {weddingConfig.scrollHint}
          </span>
          <div className="flex h-9 w-5 items-start justify-center rounded-full border border-background-50/50 p-1">
            <span className="h-1.5 w-0.5 animate-bounce rounded-full bg-background-50/80" />
          </div>
        </div>
      </div>
    </section>
  );
}